import {
    GET_CASE_DETAILS_REQUEST,
    GET_AVAILABLE_UNITS_REQUEST,
    EDIT_CASE_DETAILS_REQUEST,
    CANCEL_CASE_REQUEST,
    CONVERT_CASE_REQUEST,
    EDIT_ADMIN_CASE_NOTES_REQUEST,
    CHANGE_CASE_STATUS_REQUEST
} from "./constants";
import {
    getCaseSuccess,
    getCaseFailure,
    getAvailableUnitsSuccess,
    getAvailableUnitsFailure,
    editCaseSuccess,
    editCaseFailure,
    cancelCaseFailure,
    cancelCaseSuccess,
    convertCaseSuccess,
    convertCaseFailure,
    editAdminCaseNotesSuccess,
    editAdminCaseNotesFailure,
    changeCaseStatusSuccess,
    changeCaseStatusFailure
} from "./actions";
import {call, put, takeLatest} from "redux-saga/effects";
import remote from "../../../../services/remote";
import SentryManager from "../../../../monitoring/Sentry";

function* getCaseDetails (action) {
    const url = `/bookings/get-booking/${action.caseId}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });
        if (response.success) {
            yield put(getCaseSuccess(response.data));
        } else {
            yield put(getCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAvailableUnits (action) {
    try {
        const response = yield call(remote, {
            route: "/bookings/get-available-units",
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getAvailableUnitsSuccess(response.data));
        } else {
            yield put(getAvailableUnitsFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* editCaseDetails (action) {
    try {
        const response = yield call(remote, {
            route: "/bookings/edit-booking",
            method: 'put',
            body: JSON.stringify(action.data.patient)
        });
        if (response.success) {
            yield put(editCaseSuccess(response.data));
            yield call(action.data.callBack)
        } else {
            yield put(editCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* cancelCase (action) {
    try {
        const response = yield call(remote, {
            route: "/bookings/cancel-booking",
            method: 'delete',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(cancelCaseSuccess(response.data));
        } else {
            yield put(cancelCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* convertCase (action) {
    try {
        const response = yield call(remote, {
            route: "/admin/bookings/convert-booking",
            method: 'post',
            body: JSON.stringify({caseId: action.data.caseId, parentId: action.data.parentId})
        });
        if (response.success) {
            yield put(convertCaseSuccess(response.data));
        } else {
            yield put(convertCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}


function* editAdminCaseNotes (action) {
    try {
        const response = yield call(remote, {
            route: "/admin/bookings/edit-case-notes",
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(editAdminCaseNotesSuccess(response.data));
        } else {
            yield put(editAdminCaseNotesFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* changeCaseStatus (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/bookings/change-booking-status',
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(changeCaseStatusSuccess(response.data));
        } else {
            yield put(changeCaseStatusFailure());
        }
    } catch (e) {
        console.error(e);
    }
}

export default function* watchAdminCaseDetails() {
    yield takeLatest(CANCEL_CASE_REQUEST , cancelCase);
    yield takeLatest(GET_CASE_DETAILS_REQUEST , getCaseDetails);
    yield takeLatest(EDIT_CASE_DETAILS_REQUEST , editCaseDetails);
    yield takeLatest(GET_AVAILABLE_UNITS_REQUEST , getAvailableUnits);
    yield takeLatest(CONVERT_CASE_REQUEST , convertCase);
    yield takeLatest(EDIT_ADMIN_CASE_NOTES_REQUEST , editAdminCaseNotes);
    yield takeLatest(CHANGE_CASE_STATUS_REQUEST, changeCaseStatus)
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AdminCaseDetails/saga.js